<template>
	<div class="phelites">
		<el-backtop ></el-backtop>
		<hpheader></hpheader>

		<div class="position-bar-container">
			<position-bar :positionNav="positionNav">
			</position-bar>
		</div>

		<div class="phelitebanner">
			<div class="phelitebanner-img">
				<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phelitesimg/phelitesbanner.png" />
				<div class="phelitebanner-title">{{info.title}}</div>
			</div>
		</div>
		<div class="phelitetopnav">
			<div class="phelitetopnav-left">
				<div class="phelitetop-item"   :style="acindex==1?'color:'+$store.state.themeColor:''" @click="aciscoll(1)" >  {{info.all}}  </div>
				<div class="phelitetop-item" :style="acindex==2?'color:'+$store.state.themeColor:''" @click="aciscoll(2)" >  {{info.society}}  </div>
				<div class="phelitetop-item" :style="acindex==3?'color:'+$store.state.themeColor:''" @click="aciscoll(3)" >  {{info.campus}}  </div>
			</div>
			<div class="phelitetopnav-right" :style="acindex==4?'color:'+$store.state.themeColor:''" @click="aciscoll(4)">
				{{info.excel}}
				<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phelitesimg/phelitesdown.png" />
			</div>
		</div>
		<div class="recruitment"  >
			<div class="recruitment-left">
				<div class="recruitmentleft-item"  @click="leftnavi(0)"  :style="leftindex==0?'color:'+$store.state.themeColor:''">
					{{info.all}} 
				</div>
				<div class="recruitmentleft-item" v-for="(item,index) in channeljob" @click="leftnavi(item.id)" :key='index' :style="leftindex==item.id?'color:'+$store.state.themeColor:''">
					{{item.name}}
				</div>
			</div>
			<div class="recruitment-right" >
				<div class="recruitmentright-item" v-for="(item,index) in videoclassliststtcontsecz">
					<div class="recruitmentrigh-name">
						<div class="recruitmentrigh-namelef">{{item.name}}</div>
						<div class="recruitmentrigh-namerig" @click="recrnone(item.id)">
							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phelitesimg/phelitesxia.png" />
						</div>
					</div>
					<div class="recruitmentrigh-title">{{item.mark}}</div>
					<div class="recruitmentrigh-title">{{item.class_id_text}}  {{item.time}}</div>
					<div class="recruitmentrightcont" v-if="!item.mess1">
						<div v-html="item.content">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="process">
			<div class="process-hea">{{info.process}}</div>
			<div class="process-foo">
				<div class="recprocess-imga">
					<div class="imga-begl">
						<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesresum.png" />
						<div class="imaa-title">{{info.delivery}}</div>
					</div>
					<div class="imga-minl">
						<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesnext.png" />
					</div>
					<div class="imga-begl">
						<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesinter.png" />
						<div class="imaa-title">{{info.propaganda}}</div>
					</div>
					<div class="imga-minl">
						<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesnext.png" />
					</div>
					<div class="imga-begl">
						<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/eliteslecture.png" />
						<div class="imaa-title">{{info.interview}}</div>
					</div>
					<div class="imga-minl">
						<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesnext.png" />
					</div>
					<div class="imga-begl">
						<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesemplo.png" />
						<div class="imaa-title">{{info.examination}}</div>
					</div>
					<div class="imga-minl">
						<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesnext.png" />
					</div>
					<div class="imga-begl">
						<img src="https://api.glzmn.com/uploads/icon-file/emplo.svg" />
						<div class="imaa-title">{{info.employment}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="phfaq">
			<div class="faqheader">
				{{info.faq}}
			</div>
			<div class="phfaqfoo"  v-for="(item,index) in elitefaq">
				<div class="phfaqfoo-hea">
					{{item.name}}
				</div>
				<div class="phfaqfoo-title" v-html="item.content">
				</div>
			</div>
		</div>
		<div class="environment">
			<div class="envionment-hea">{{info.userIn}}</div>
			<div class="envionment-item" >
				<div class="envionment-foo" @click="navtophfilew(1)">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phelitesimg/phelitesimg4.png" />
					<div class="envionment-title">{{info.around}}</div>
				</div>
				<div class="envionment-foo" @click="navtophfilew(2)">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phelitesimg/phelitesimg2.png" />
					<div class="envionment-title">{{info.happy}}</div>
				</div>
				<div class="envionment-foo" @click="navtophfilew(3)">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phelitesimg/phelitesimg1.png" />
					<div class="envionment-title">{{info.welfare}}</div>
				</div>
				<div class="envionment-foo" @click="navtophfilew(4)">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phelitesimg/phelitesimg3.png" />
					<div class="envionment-title">{{info.train}}</div>
				</div>
			</div>
		</div>
		<hpfooter></hpfooter>
	</div>
</template>

<script>

	import hpheader from '../../common/hpheader.vue'
	import hpfooter from '../../common/hpfooter.vue'
	import {session} from "../../storage/storage";
	import positionBar from '../../components/ph-position-bar.vue'

	export default{
		data(){
			return{
				recrnonecn:'',
				id:'',
				oldScrollTop: 0,
				leftindex:0,
				navheader:true,
				heshow:false,
				show: false,
				playli:true,
				playri:true,
				acindex:1,
				producheanon:true,
				campus:1,
				channeljob:'',
				hannel:[],
				videoclassliststtcontsecz:[],
				elitefaq:'',
				queryxsla:'',
				info:{
					user : "用户服务",
					all : "全部",
					society: "社会招聘",
					campus: "校园招聘",
					excel: "应聘登记表下载",
					title: "啄尔不凡  属你非凡",
					hot:"热门招聘职位",
					name: "职位名称",
					type: "职位类别",
					salary:"薪资待遇",
					time:"发布时间",
					detail:"详情介绍",
					open:"展开详情",
					process:'招聘流程',
					faq:"FAQ",
					delivery:"投递简历",
					propaganda:"宣传会",
					interview:"面试",
					employment:"录用",
					around:"工作环境",
					happy:"快乐生活",
					welfare:"薪资福利",
					train:"培训发展",
					userIn:'人在啄木鸟',
				},
				value: '',
				valuelang: '',
				platese:0,
				positionNav:[
					{
						title:'Home',
						path:'/phhome',
					},
					{
						title:'Contact Us',
						path:'/phcontactus',
					},
					{
						title:'Join Us',
						path:'',
					},
				]
			}
		},
		created() {
			window.scrollTo(0,0);
			this.acindex = this.$route.query.select
			this.ress()
			this.getParam()
			this.pcchanneljobtype()
			 this.pcchanneljoblis()
			 this.pcget_faq()
			// this.getqueryxsls()
		},
		mounted() {
			if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {

				
			}else{
				this.$router.push({path:'./pcelites',query:{e:this.$route.query.e}})
				return
			}
			this.ress()

		},
		components:{
			hpfooter,
			hpheader,
			positionBar
		},
		methods:{
			navtophfilew(e){
				this.$router.push({path: '/phfilework',query:{e}})
			},
			pcchanneljobtype(){
				let data={
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
						page:1,
						pageSize:100,
						
					}
				this.$api.get_channel_job_type(data).then((res) => {
						this.channeljob=res.data
						  
				});
			},
			aciscoll(e){

				this.acindex=e
				if(e==4){
					/* console.log('000',this.queryxsla) */
					var name = 'Application Form';
					var url = this.queryxsla;
					var suffix = url.substring(url.lastIndexOf("."), url.length);
					//跳过浏览直接下载
					fetch(url)
							.then(res => res.blob())
							.then(blob => {
								const a = document.createElement("a");
								const objectUrl = window.URL.createObjectURL(blob);
								a.download = name;
								a.href = objectUrl;
								a.click();
								window.revokeObjectURL(objectUrl);
							})
					/* document.getElementById("inscte").scrollIntoView(); */
				}else if(e==2){
					this.platese=2
					this.pcchanneljoblis()
					this.campus=2
					/* document.getElementById("paradme").scrollIntoView(); */
				}else if(e==3){
					this.platese=1
					this.pcchanneljoblis()
				}else if(e==1){
					this.platese=0
					this.pcchanneljoblis()
				}

			},
			pcchanneljoblis(){

				let data={
					type_id:this.leftindex,
					plate:this.platese,
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
					page:1,
					pageSize:100,

				}
				this.$api.get_channel_job_list(data).then((res) => {
					this.hannel=res.data
					this.videoclassliststtcontsecz=[]
					this.hannel.map(((item, index)=> {
					this.videoclassliststtcontsecz.push(Object.assign({},item,{mess1:true,mess2:8}))
					}))
					console.log(this.videoclassliststtcontsecz)
					/* this.channeljoblist=res.data */

				});
			},
			leftnavi(e){
				this.leftindex=e
				this.pcchanneljoblis()
			},
			getParam(){
				let lang =  session.get("lang");
				if (lang === "cn"){
					this.info = {
						user : "用户服务",
						all : "全部",
						society: "社会招聘",
						campus: "校园招聘",
						excel: "应聘登记表下载",
						title: "啄尔不凡  属你非凡",
						hot:"热门招聘职位",
						name: "职位名称",
						type: "职位类别",
						salary:"薪资待遇",
						time:"发布时间",
						detail:"详情介绍",
						open:"展开详情",
						process:'招聘流程',
						faq:"FAQ",
						delivery:"投递简历",
						propaganda:"宣传会",
						interview:"面试",
						employment:"录用",
						around:"工作环境",
						happy:"快乐生活",
						welfare:"薪资福利",
						train:"培训发展",
						userIn:'人在啄木鸟',
					}
				}else{
					this.info = {
						user : "Users Service",
						all : "All",
						society: "General Recruitment",
						campus: "Campus Recruitment",
						excel: "Form",
						title: "Hero Meets Hero",
						hot:"Popular recruitment positions",
						name: "Job title",
						type: "Position category",
						salary:"Salary",
						time:"Release time",
						detail:"Details",
						open:"Deployment details",
						process:'Recruitment Process',
						faq:"FAQ",
						delivery:"CV Delivery",
						propaganda:"Career Talk",
						interview:"Interview",
						examination:"Check-Up",
						employment:"Offer",
						around:"Work Environment",
						happy:"Happy Life",
						welfare:"Salary And Welfare",
						train:"Training Development",
						userIn:'People Are Pecking At Woodpeckers',
					}
				}
			},
			pcget_faq(){
				let data={
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
					page:1,
					pageSize:100,

				}
				this.$api.get_faq(data).then((res) => {
					this.elitefaq=res.data


				});
			},
			recrnone(e){
				for(let l =0;l<this.videoclassliststtcontsecz.length;l++){
					if(this.videoclassliststtcontsecz[l].id==e){
						if(this.videoclassliststtcontsecz[l].mess1){
							this.videoclassliststtcontsecz[l].mess1=false
						}else{
							this.videoclassliststtcontsecz[l].mess1=true
						}
					}
				}
			},
			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
		}
	}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
	}
	.phelites{
		background: #FFF;
		padding-top: 0.88rem;
	}
	.phproduct-hea{
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 7.5rem;
		height: 0.88rem;
		background: #FFFFFF;
	}
	.phproducthea-left{
		margin-left: 0.3rem;
		width: 0.97rem;
		height: 0.5rem;
	}
	.phproducthea-left img{
		width: 100%;
		height: 100%;
	}
	.phproducthea-right{
		margin-right: 0.3rem;
		width: 0.38rem;
		height: 0.38rem;
	}
	.phproducthea-right img{
		width: 100%;
		height: 100%;
	}
	.phelitebanner{
		
	}
	.phelitebanner-img{
		position: relative;
		width: 7.5rem;
		height: 4rem;
	}
	.phelitebanner-img img{
		width: 7.5rem;
		height: 4rem;
	}
	.phelitebanner-title{
		width: 7.5rem;
		height: 4rem;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		text-align: center;
		top: 0rem;
		left:0rem;
		font-size: 0.6rem;
		font-weight: normal;
		color: #FFFFFF;
		letter-spacing: 0.03rem;
	}
	.phelitetopnav{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: 0.4rem;
		background: #FAFAFA;
	}
	.phelitetopnav-left{
		
		display: flex;
		align-items: center;
		font-size: 0.28rem;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		margin-left: 0.3rem;
	}
	.phelitetop-item{
		margin-right: 0.3rem;
		text-align: center;
	}
	.phelitetopnav-right{
		width: 2.3rem;
		height: 0.44rem;
		border-radius: 0.04rem;
		border: 0.01rem solid #666666;
		font-size: 0.2rem;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 0.3rem;
	}
	.phelitetopnav-right img{
		width: 0.2rem;
		height: 0.2rem;
		margin-left: 0.1rem;
	}
	.recruitment{
		display: flex;
		background: #FAFAFA;
		padding-top: 0.36rem;
	}
	.recruitment-left{
		
	}
	.recruitmentleft-item{
		width: 1.6rem;
		height: 0.8rem;
		background: #EAEAEA;
		font-size: 0.2rem;
		font-weight: 400;
		color: #000;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 0.06rem;
		text-align: center;
	}
	.recruitment-right{
		margin-left: 0.24rem;
		margin-right: 0.3rem;
		
	}                                                                                                
	.recruitmentright-item{
		display: flex;
		flex-direction: column;
		width: 5.4rem;
		margin-bottom: 0.5rem;
	}
	.recruitmentrigh-name{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.recruitmentrigh-namelef{
		font-size: 0.32rem;
		font-weight: 600;
		color: #5d5f5f;
	}
	.recruitmentrigh-namerig{
		display: flex;
		width: 0.32rem;
		height: 0.32rem;
	}
	.recruitmentrigh-namerig img{
		width: 100%;
		height: 100%;
	}
	.recruitmentrigh-title{
		font-size: 0.24rem;
		font-weight: 400;
		color: #666666;
		margin-top: 0.12rem;
	}
	.recruitmentrightcont{
		
		margin-top: 0.12rem;
		/* min-width: 1.36rem; */
		min-height: 1.35rem;
		background: #FFFFFF;
		font-size: 0.16rem;
	}
	.recruitmentrightcont p , .recruitmentrightcont span , .recruitmentrightcont div {
		color: #5d5f5f!important;
		font-size: 0.16rem!important;
	}
	.cc{
		color: #D03E3D;
	}
	.imga-minl{
		display: flex;
	}
	.recprocess-imga{
		/* margin-left: 0.2rem; */
	}
	.recprocess-imga{
		display: flex;
		align-items: center;
		justify-content: center;
		
	}
	.imga-begl{
		width: 1rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 0.2rem;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		/*margin-right: 0.3rem;*/
	}
	.imga-begl:last-child{
		/* margin-right: 0px; */
	}
	.imga-begl img{
		width: 0.87rem;
		height: 0.87rem;
		margin-bottom: 0.2rem;
		
	}
	.imga-minl{
		width: 0.23rem;
		height: 0.15rem;
		margin-top: -0.3rem;
		/*margin-right: 0.3rem;*/
		padding: 0 .1rem;
	}
	.imga-minl:last-child{
		/* margin-right: 88px; */
	}
	.imga-minl img{
		width: 100%;
		height: 100%;
	}
	.process-hea{
		font-size: 0.36rem;
		font-weight: 500;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 0.4rem;
		margin-bottom: 0.61rem;
	}
	.phfaq{
		padding-top: 0.6rem;
	}
	.faqheader{
		font-size: 0.36rem;
		font-weight: 500;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 0.24rem;
	}
	.phfaqfoo{
		margin-left: 0.3rem;
		margin-right: 0.3rem;
	}
	.phfaqfoo-hea{
		font-size: 0.24rem;
		font-weight: 600;
		color: #5d5f5f;
	}
	.phfaqfoo-title{
		font-size: 0.2rem;
		font-weight: 400;
		color: #666666;
		margin-top: 0.12rem;
		margin-bottom: 0.24rem;
		
	}
	.environment{
		background: #FAFAFA;
		padding-top: 0.4rem;
	}
	.envionment-hea{
		font-size: 0.36rem;
		font-weight: 500;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 0.24rem;
	}
	.envionment-foo{
		width: 3.35rem;
		height: 1.59rem;
		position: relative;
		margin-right: 0.2rem;
		margin-bottom: 0.19rem;
	}
	.envionment-foo:nth-child(2n){
		margin-right: 0rem;
	}
	.envionment-foo img{
		width: 3.35rem;
		height: 1.59rem;
	}
	.envionment-title{
		width: 3.35rem;
		height: 1.59rem;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		font-size: 0.4rem;
		font-weight: 600;
		color: #FFFFFF;
		letter-spacing: 0.02rem;
		top: 0rem;
		left: 0rem;
	}
	.envionment-item{
		display: flex;
		flex-wrap: wrap;
		margin-left: 0.3rem;
		margin-right: 0.3rem;
	}
	.imaa-title{
		/*height: 0.7rem;*/
		display:block;
		word-break:keep-all;
		white-space:nowrap;
		overflow:hidden;
		text-overflow:ellipsis;
	}
</style>
